import React from 'react';
import type { FC } from 'react';

import { useSMSInboxCount } from '@admin/hooks/use_sms_inbox_count';

export const NavBarSMSInboxCountBadge: FC = () => {
  const count = useSMSInboxCount();
  if (!count) return null;
  return <span className="badge badge-info">{count}</span>;
};
